export default __webpack_public_path__ + "static/media/adoption.74165829.svg";